import React, { Component } from 'react';
import { QUEUE_NAMES } from '@bit/gerenciatd.utils.context';
import { Helmet } from 'react-helmet';

/* que este se subscriba a seo y escriba verdad? */
class MetaData extends Component {
  state = {
    seoInfo: null,
  };

  componentDidMount = () => {
    const { projectId, seoCustomValue, pageId, pageWithExtraInfo } = this.props;
    const aliasFront = seoCustomValue || '{}';
    const { segment } = this.props;
    const reqData = {
      SEG_NAV: segment,
      location: `${pageId}`,
      customValues: aliasFront,
    };
    // preguntamos a context
    const match = this.props.match || null;
    const params = (match && match.params) || null;
    if (pageWithExtraInfo && match && params) {
      let myUrl = reqData.location;
      const paramsKeys = Object.keys(params);
      paramsKeys.forEach((key) => {
        const value = params[key];
        myUrl = myUrl.replace(`:${key}`, value);
      });
      reqData.location = myUrl;
    }
    window.nookInfoExchange.sendMessage('SEO_PARAMS', reqData);

    // respuesta de context
    window.nookInfoExchange.registerAsObserver(
      QUEUE_NAMES.SEO_DATA,
      `${projectId}-SEO`,
      (seoData) => {
        window.nookInfoExchange.cleanObserver(
          QUEUE_NAMES.SEO_DATA,
          `${projectId}-SEO`,
        );
        this.setState({ seoInfo: seoData });
        this.props.onFinish(seoData);
      },
    );
  };

  render() {
    const { seoInfo } = this.state;
    if (!seoInfo) {
      return null;
    }
    const seoInfoKeys = seoInfo ? Object.keys(seoInfo) : [];
    if (seoInfoKeys.length === 0) {
      return null;
    }
    /* eslint-disable camelcase */
    const {
      /* basics first level values */
      title,
      description,
      keywords,
      robots,
      canonical,
    } = seoInfo;
    /* modifications dates */
    const { dateModified, datePublished, dateCreated } = seoInfo;
    /* rrss_fb */
    const { rrss_fb } = seoInfo;
    const fbTitle = rrss_fb && rrss_fb['og:title'] ? rrss_fb['og:title'] : '';
    const fbType = rrss_fb && rrss_fb['og:type'] ? rrss_fb['og:type'] : '';
    const fbImage = rrss_fb && rrss_fb['og:image'] ? rrss_fb['og:image'] : '';
    const fbUrl = rrss_fb && rrss_fb['og:url'] ? rrss_fb['og:url'] : '';
    const fbDescription =
      rrss_fb && rrss_fb['og:description'] ? rrss_fb['og:description'] : '';
    const fbSiteName = rrss_fb && rrss_fb.site_name ? rrss_fb.site_name : '';
    /* x aki vamos */
    const { search_engines_verification } = seoInfo;
    /* microdata */
    const { microdata_product, microdata_website, breadcrums } = seoInfo;
    return (
      <Helmet>
        {/* basics first level values */}
        {title && <title>{title}</title>}
        {description && <meta name="description" content={description} />}
        {keywords && <meta name="keywords" content={keywords} />}
        {robots && <meta name="Robots" content={robots} />}
        {canonical && <link rel="canonical" href="https://www.movistar.es" />}
        <meta name="author" content="Movistar" />
        <meta name="owner" content="Movistar" />
        {/* modifications dates */}
        {dateModified && (
          <meta itemProp="dateModified" content={dateModified} />
        )}
        {datePublished && (
          <meta itemProp="datePublished" content={datePublished} />
        )}
        {dateCreated && <meta itemProp="dateCreated" content={dateCreated} />}
        {/* rrss_fb */}
        {fbTitle && <meta property="og:title" content={fbTitle} />}
        {fbImage && <meta property="og:image" content={fbImage} />}
        {fbType && <meta property="og:type" content={fbType} />}
        {fbUrl && <meta property="og:url" content={fbUrl} />}
        {fbDescription && (
          <meta property="og:description" content={fbDescription} />
        )}
        {fbSiteName && <meta property="og:site_name" content="Movistar" />}
        {/* search_engines_verification */}
        {search_engines_verification &&
          search_engines_verification.length > 0 &&
          search_engines_verification.map((item) => {
            const keyName = Object.keys(item)[0] || '';
            const value = item[keyName] || '';
            return (
              <meta
                key={`${keyName}-${value}`}
                name={keyName}
                content={value}
              />
            );
          })}
        {microdata_product && (
          <script type="application/ld+json">
            {JSON.stringify(microdata_product)}
          </script>
        )}
        {microdata_website && (
          <script type="application/ld+json">
            {JSON.stringify(microdata_website)}
          </script>
        )}
        {breadcrums && (
          <script type="application/ld+json">
            {JSON.stringify(breadcrums)}
          </script>
        )}
      </Helmet>
    );
  }
}

export default MetaData;
